export default __webpack_public_path__ + "static/media/iconArrowLeft.6acbfde6.svg";